import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material'
import { ErrorOutline } from '@mui/icons-material'
import { useAuthStore } from '@store/authStore'

export interface ErrorDialogProps {
  open: boolean
  title?: string
  message: string
  details?: string
  onClose: () => void
}

export function ErrorDialog({
  open,
  title = 'Operation Failed',
  message,
  details,
  onClose,
}: ErrorDialogProps) {
  // Check if current user is an admin
  const user = useAuthStore((state) => state.user)
  const isAdmin = user?.roles?.includes('admin') || user?.roles?.includes('Admin') || false

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="error-dialog-title"
    >
      <DialogTitle id="error-dialog-title">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ErrorOutline color="error" />
          <Typography variant="h6" component="span">
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="error" sx={{ mb: 2, whiteSpace: 'pre-line' }}>
          {message}
        </Alert>

        {details && isAdmin && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Technical details (Admin only):
            </Typography>
            <Typography
              variant="caption"
              component="pre"
              sx={{
                p: 1,
                backgroundColor: '#f5f5f5',
                borderRadius: 1,
                overflow: 'auto',
                maxHeight: '200px',
              }}
            >
              {details}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}
